import React from "react";
import { IconType } from "react-icons";
import styled from "styled-components";
import { space, SpaceProps } from "styled-system";

const Wrap = styled.div<SpaceProps & { compact: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: ${(p) => (p.compact ? "24px 16px" : "48px 24px")};
  ${space};
`;

const IconBubble = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-bottom: 12px;
  border-radius: 999px;
  font-size: 18px;
  background: ${(p) => p.theme.colors.sunken ?? p.theme.colors.grey6};
  color: ${(p) => p.theme.colors.grey ?? p.theme.colors.grey2};
`;

const Title = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: ${(p) => p.theme.colors.black};
`;

const Body = styled.div`
  margin: 4px 0 0;
  max-width: 44ch;
  font-size: 14px;
  line-height: 1.45;
  color: ${(p) => p.theme.colors.textMuted ?? p.theme.colors.grey1};
`;

const Action = styled.div`
  margin-top: 16px;
`;

export type EmptyStateProps = {
  icon?: IconType;
  title?: React.ReactNode;
  /** One sentence: what goes here, and how it gets filled. */
  children?: React.ReactNode;
  /** At most one button or link. */
  action?: React.ReactNode;
  /** Less padding, for inside a card. */
  compact?: boolean;
} & SpaceProps;

/** What an empty list or page shows instead. */
export function EmptyState({
  icon: Icon,
  title,
  children,
  action,
  compact = false,
  ...rest
}: EmptyStateProps) {
  return (
    <Wrap compact={compact} {...rest}>
      {Icon && (
        <IconBubble aria-hidden="true">
          <Icon />
        </IconBubble>
      )}
      {title != null && <Title>{title}</Title>}
      {children != null && <Body>{children}</Body>}
      {action != null && <Action>{action}</Action>}
    </Wrap>
  );
}
